<template>
	<b-modal
		class="update-lesson-modal"
		:visible="show"
		@hide="() => this.$emit('close')"
		@ok="() => $emit('updateLesson')"
		:title="
			'WARNING! After re-saving the task, the students who completed this task will have the puzzle closed and will have to do it again.'
				| translate
		"
		:ok-title="'Confirm' | translate"
		:cancel-title="'Cancel' | translate"
	/>
</template>

<script>
export default {
	name: 'modal-update-lesson',
	props: ['show', 'updateLesson'],
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.update-lesson-modal {
	.modal-body {
		display: none;
	}

	.modal-footer {
		justify-content: space-between;
	}
}
</style>
